import { TranslationString } from 'shared/entities/localization';

import { TariffKind } from '../tariff';

export type PaymentMethodServer = {
  _id: string;
  title: string;
  type: string;
  date_created: string;
};

export type BillingServer = {
  balance: number;
  legal_entity_balance?: number;
  trial_until: string;
  tariff: TariffKind;
};

export type PaymentInfoServer = {
  methods: PaymentMethodServer[];
  billing: BillingServer;
  optimal_tariff: TariffKind;
  day_price: number;
  month_price: number;
  should_pay: boolean;
  users_count: number;
  max_users_count: number | null; // null для безлимитного по пользователям тарифа
  /**
   * Дата следующего списания с карты. Учитывает наличие триала. null для корп тарифа
   */
  next_payment_date: string | null; //
  /**
   * Число дней, на которое хватит денег с учетом триала (то есть через сколько дней боты остановятся) // null для корп тарифа
   */
  days_left: number | null;
  /**
   * Дата, когда боты остановятся (до какой даты хватит денег с учетом триала)  // null для корп тарифа
   */
  bankrupt_date: string | null;
  is_profitable: boolean;
  minimal_payment: number;
  date_invoice_autogenerated?: string | null;
  /**
   * Приходит, если отправить with_payments_count
   */
  payments_count?: number;
};

export type PaymentPromoServer = {
  original_price: number;
  price_to_pay: number;
  discount_per_months: {
    discount: number;
    number_of_months: number;
  } | null;
  discount_for_promocode: {
    discount: number;
    promocode: string;
  } | null;
};

export enum PromoCodeKind {
  discount = 'discount',
  testPeriod = 'test_period'
}

export type CheckPromoCodeServer = {
  kind: PromoCodeKind;
  value: number;
};

export type PaymentParams = (
  | {
      amount: number;
    }
  | {
      number_of_months: number;
    }
  | {}
) & {
  promocode?: string;
  tariff?: TariffKind;
};

export enum CheckPromoCodeError {
  notValid = 'promocode_not_valid',
  notFound = 'promocode_not_found',
  alreadyUsed = 'promocode_already_used_for_cabinet'
}

export enum PromoCodeKindError {
  invalidPromocodeKind = 'invalid_promocode_kind'
}

export enum CalculatePayErrorCode {
  amountTooLow = 'amount_too_low',
  shouldPayAsLegalEntity = 'should_pay_as_legal_entity',
  invalidPromocodeKind = 'invalid_promocode_kind'
}

export type CalculatePayError =
  | CheckPromoCodeError
  | CalculatePayErrorCode
  | PromoCodeKindError;

export type ApplyPromoCodeError = CheckPromoCodeError | PromoCodeKindError;

export const mapCalculatePayErrorToMessage =
  (code: CalculatePayError): TranslationString =>
  (t) =>
    t(`payment.errors.calculatePay.${code}`, {
      ns: 'entities'
    });

export enum PaymentAddition {
  month = 'month',
  sum = 'sum'
}

export type AvailableMonthCount = 1 | 3 | 6 | 12;

export const availableMonthPayments: {
  count: AvailableMonthCount;
  sale: string;
}[] = [
  { count: 1, sale: '' },
  { count: 3, sale: '-5%' },
  { count: 6, sale: '-10%' },
  { count: 12, sale: '-20%' }
];

export const mapAvailableMonthPaymentsToSale: Record<
  AvailableMonthCount,
  string
> = {
  1: '',
  3: '-5%',
  6: '-10%',
  12: '-20%'
};

const SUM_PAYMENTS_NUMBER = 3;

export const getAvailableSumPayments = (minimalPayment: number): number[] => {
  const availableSumPayments = [3000, 6000, 10000, 15000, 30000, 50000, 100000];

  const sums = availableSumPayments.reduce<number[]>(
    (acc, sum) => {
      if (sum > minimalPayment) {
        acc.push(sum);
      }

      return acc;
    },
    [minimalPayment]
  );

  return sums.slice(0, SUM_PAYMENTS_NUMBER);
};

export type GetPaymentInfoRequestParams = {
  with_payments_count?: boolean;
};
